import { detach, getParent, getParentOfType, getType, isRoot, } from 'mobx-state-tree';
import { v4 } from 'uuid';
import schema, { generateType, } from './Schema';
import { moveItem } from './CourseModel';
export const Hub = generateType(schema.getModel('hub'))
    .actions((self) => ({
    initCategories() {
        // don't reinit
        if (self.categories && self.categories.length > 0) {
            return;
        }
        self.categories = [
        // not used
        ];
    },
    addCategory(name) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const newCategory = HubCategory.create({
            id: v4(),
            name,
        });
        self.subCategories.push(newCategory);
        self.addChange();
        return newCategory;
    },
}))
    .views((self) => ({
    getCategory(categoryId) {
        if (self.syncState !== 'loaded') {
            throw Error(`Hub must be loaded before calling getCategory: ${self.id}, ${self.syncState}`);
        }
        for (let i = 0; i < self.categories.length; i += 1) {
            const c = self.categories[i];
            const foundCat = c.getSubCategory(categoryId);
            if (foundCat) {
                return foundCat;
            }
        }
        return undefined;
    },
    getCategoryPath(categoryId) {
        if (self.syncState !== 'loaded') {
            throw Error(`Hub must be loaded before calling getCategory: ${self.id}, ${self.syncState}`);
        }
        for (let i = 0; i < self.categories.length; i += 1) {
            const c = self.categories[i];
            const path = c.getCategoryPath(categoryId);
            if (path) {
                // note we are returning the top category here
                return path;
            }
        }
        throw new Error(`Category not found ${categoryId}`);
    },
}))
    .actions(() => ({}));
const hubCategoryModel = generateType(schema.getModel('hubCategory'));
export const HubCategory = hubCategoryModel
    .views(() => ({
    isAncestor(child, possibleParent) {
        let parent = getParent(child);
        while (parent) {
            if (parent === possibleParent) {
                // console.log('Is an ancestor', {child: child.name, parent: possibleParent.name});
                return true;
            }
            parent = isRoot(parent) ? null : getParent(parent);
        }
        // console.log('Not an ancestor', {child: child.name, parent: possibleParent.name});
        return false;
    },
}))
    .actions((self) => ({
    addChange() {
        try {
            getParentOfType(self, Hub).addChange();
        }
        catch (e2) {
            console.log('error adding change', e2);
        }
    },
    addCategory(name) {
        const newCategory = HubCategory.create({
            id: v4(),
            name,
            displayInNavigation: true,
            active: true,
        });
        self.subCategories.push(newCategory);
        this.addChange();
        return newCategory;
    },
    removeCategory(subCategory) {
        detach(subCategory);
        this.addChange();
    },
    insertCategory(subCategory, atIndex) {
        if (atIndex < 0) {
            self.subCategories.push(subCategory);
        }
        else {
            self.subCategories.splice(atIndex, 0, subCategory);
        }
        this.addChange();
    },
    moveSubCategory(subCategory, newIndex) {
        const currentIndex = self.subCategories.indexOf(subCategory);
        const adjustedNewIndex = newIndex > currentIndex ? newIndex - 1 : newIndex;
        const tempArray = self.subCategories.slice();
        moveItem(tempArray, currentIndex, adjustedNewIndex);
        self.subCategories.replace(tempArray);
        this.addChange();
    },
    /**
   * Moves a category to a new location in the course tree.
   *
   * @param categoryToMove
   * @param target
   * @param index
   */
    moveCategory(categoryToMove, newParent, newIndex) {
        // if moving within the same list - need to adjust the index
        const currentParent = categoryToMove.getParent();
        if (currentParent.id === newParent.id) {
            currentParent.moveSubCategory(categoryToMove, newIndex);
        }
        else {
            currentParent.removeCategory(categoryToMove);
            newParent.insertCategory(categoryToMove, newIndex);
        }
        this.addChange();
    },
    deleteItem(item) {
        const deleteIndex = self.items.indexOf(item);
        self.items.splice(deleteIndex, 1);
        self.addChange();
    },
}))
    .views((self) => ({
    getParent() {
        const parent = getParent(self, 2);
        // console.log('type', getType(parent));
        if (getType(parent).name === 'Portal') {
            return null;
        }
        return parent;
    },
    canAdd() {
        // @todo - not if we are top level
        return true;
    },
    canDelete() {
        // @todo can't delete root categories
        if (self.subCategories.length > 0) {
            return false;
        }
        return true;
    },
    getSubCategory(categoryId) {
        // console.log('Looking in/for', { self: self.id, categoryId });
        if (categoryId === self.id) {
            return self;
        }
        let foundCat;
        // check my subs
        for (let i = 0; i < self.subCategories.length; i += 1) {
            const subCat = self.subCategories[i];
            foundCat = subCat.getSubCategory(categoryId);
            if (foundCat) {
                return foundCat;
            }
        }
        return undefined;
    },
    getCategoryPath(categoryId) {
        // console.log('Looking in/for', { self: self.id, categoryId });
        if (categoryId === self.id) {
            return [self];
        }
        // check my subs
        for (let i = 0; i < self.subCategories.length; i += 1) {
            const subCat = self.subCategories[i];
            const foundPath = subCat.getCategoryPath(categoryId);
            if (foundPath) {
                return [self, ...foundPath];
            }
        }
        return undefined;
    },
    canReceive(categoryToMove, newParent, newIndex) {
        if (!newParent) {
            console.log('newParent', newParent);
            return false;
        }
        // if moving within the same list - need to adjust the index
        const currentParent = categoryToMove.getParent();
        const currentIndex = currentParent.subCategories.indexOf(categoryToMove);
        // if a section has an item, into cant receive items or subsections
        if (!newParent.canAdd()) {
            return false;
        }
        // already here
        if (currentParent.id === newParent.id
            && (newIndex === currentIndex || newIndex === currentIndex + 1)) {
            return false;
        }
        // cant move to yourself
        if (categoryToMove === newParent) {
            return false;
        }
        // cant move a node to one if its children
        if (self.isAncestor(newParent, categoryToMove)) {
            return false;
        }
        return true;
    },
}));
//# sourceMappingURL=HubModel.js.map